import { useCallback, useState } from "react";
import {
  cancelTask, moveStatusBack, moveStatusForward, reassignTask, unparkTask,
  notifyUnavailableParts, requestBillingDetails,
} from "../../models/modals-misc/queryLifecycleModel";

export function useQueryLifecycle(queryPk, userId) {
  const [pending, setPending] = useState(false);

  const run = useCallback(async (fn) => {
    setPending(true);
    try {
      return await fn();
    } finally {
      setPending(false);
    }
  }, []);

  const cancel = useCallback((reason) => run(() => cancelTask(queryPk, userId, reason)), [queryPk, userId, run]);
  const moveBack = useCallback((toStatus, reason) => run(() => moveStatusBack(queryPk, userId, toStatus, reason)), [queryPk, userId, run]);
  const moveForward = useCallback((toStatus, reason) => run(() => moveStatusForward(queryPk, userId, toStatus, reason)), [queryPk, userId, run]);
  const reassign = useCallback((toUserId, reason) => run(() => reassignTask(queryPk, toUserId, reason, userId)), [queryPk, userId, run]);
  const unpark = useCallback((toStatus, reason) => run(() => unparkTask(queryPk, userId, toStatus, reason)), [queryPk, userId, run]);
  const notifyUnavailable = useCallback(
    (messageText, partIds) => run(() => notifyUnavailableParts(queryPk, { userId, messageText, partIds })),
    [queryPk, userId, run]
  );
  const requestBilling = useCallback((messageText) => run(() => requestBillingDetails(queryPk, userId, messageText)), [queryPk, userId, run]);

  return { pending, cancel, moveBack, moveForward, reassign, unpark, notifyUnavailable, requestBilling };
}
